export const goBack = () => history.go(-1);
